import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '../ui/sidebar';
import { Header } from '../header';
import { AppSidebar, type NavItem } from '../app-sidebar';

export interface DashboardLayoutProps {
  /**
   * Navigation items for the default AppSidebar.
   * Required if `sidebar` is not provided.
   */
  navItems?: NavItem[];

  /**
   * The translation key or text for the header title.
   */
  headerTitle: string;
}

export const DashboardLayout = ({ headerTitle, navItems }: DashboardLayoutProps) => {
  return (
    <SidebarProvider>
      <AppSidebar navItems={navItems || []} />
      <SidebarInset className="min-w-0">
        <Header title={headerTitle} />
        <main className="flex-1 flex flex-col p-4 lg:p-6">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};
